




















/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DayPromiseRisk extends Vue {
  private visible = false;
  title = '';
  code: any = '';

  pubKey: any = '';
  initCount: any = 0;
  oWebControl: any = null;
  WebControl: any = null;
  private loading: any = true;
  private src: any = '';

  public async showDialog(videoArr: any) {
    // console.log(this.$route.query.code);
    // console.log(code);
    console.log(videoArr[0].code);
    console.log(videoArr[0].num);

    this.code = videoArr;
    // this.code = this.$route.query.code;
    this.title = videoArr[0].name;
    this.visible = true;
    this.WebControl = null;
    // @ts-ignore
    this.WebControl = WebControl;
    // await this.init()
    // this.initPlugin(this.code);
    // await this.startpreview()
    this.loading = true;
    const token: any = window.localStorage.getItem('videoToken');
    this.src = 'https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/' + videoArr[0].code + '/' + videoArr[0].num + '.hd.live&autoplay=1&audio=1&accessToken=' + token + '&templete=2';
  }

  private async hideDialog() {
    // await this.closeWindow();
    this.visible = false;
  }

  //初始化
  init(codeArr?: any) {
    let layoutValue = '';
    switch (codeArr.length) {
      case 1:
        layoutValue = '1x1';
        break;
      case 2:
        layoutValue = '1x2';
        break;
      case 3:
      case 4:
        layoutValue = '2x2';
        break;
      default:
        layoutValue = '3x3';
        break;
    }
    this.getPubKey(() => {
      ////////////////////////////////// 请自行修改以下变量值	////////////////////////////////////
      const appkey = '20911520'; //综合安防管理平台提供的appkey，必填
      const secret = this.setEncrypt('0NOZX5lh0muGckx8RwAX'); //综合安防管理平台提供的secret，必填
      const ip = '10.10.89.231'; //综合安防管理平台IP地址，必填
      const playMode = 0; //初始播放模式：0-预览，1-回放
      const port = 443; //综合安防管理平台端口，若启用HTTPS协议，默认443
      const snapDir = 'D:\\SnapDir'; //抓图存储路径
      const videoDir = 'D:\\VideoDir'; //紧急录像或录像剪辑存储路径
      const layout = layoutValue; //playMode指定模式的布局
      const enableHTTPS = 1; //是否启用HTTPS协议与综合安防管理平台交互，这里总是填1
      const encryptedFields = 'secret'; //加密字段，默认加密领域为secret
      const showToolbar = 1; //是否显示工具栏，0-不显示，非0-显示
      const showSmart = 1; //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
      const buttonIDs = '0,16,256,257,258,259,260,512,513,514,515,516,517,768,769'; //自定义工具条按钮
      ////////////////////////////////// 请自行修改以上变量值	////////////////////////////////////

      this.oWebControl
        .JS_RequestInterface({
          funcName: 'init',
          argument: JSON.stringify({
            appkey: appkey, //API网关提供的appkey
            secret: secret, //API网关提供的secret
            ip: ip, //API网关IP地址
            playMode: playMode, //播放模式（决定显示预览还是回放界面）
            port: port, //端口
            snapDir: snapDir, //抓图存储路径
            videoDir: videoDir, //紧急录像或录像剪辑存储路径
            layout: layout, //布局
            enableHTTPS: enableHTTPS, //是否启用HTTPS协议
            encryptedFields: encryptedFields, //加密字段
            showToolbar: showToolbar, //是否显示工具栏
            showSmart: showSmart, //是否显示智能信息
            buttonIDs: buttonIDs, //自定义工具条按钮
          }),
        })
        .then((oData: any) => {
          console.log(oData);
          this.loading = false;
          this.oWebControl.JS_Resize(900, 600); // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
          codeArr.forEach((item: any, index: any) => {
            this.startpreview(item.code, index);
          });
        });
    });
  }

  //获取公钥
  getPubKey(callback: any) {
    this.oWebControl
      .JS_RequestInterface({
        funcName: 'getRSAPubKey',
        argument: JSON.stringify({
          keyLength: 1024,
        }),
      })
      .then((oData: any) => {
        console.log(oData);
        if (oData.responseMsg.data) {
          this.pubKey = oData.responseMsg.data;
          callback();
        }
      });
  }

  //RSA加密
  setEncrypt(value: any) {
    // @ts-ignore
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(this.pubKey);
    return encrypt.encrypt(value);
  }

  //视频“预览”功能
  startpreview(code?: any, index?: any) {
    let cameraIndexCode = code; //获取输入的监控点编号值，必填
    const streamMode = 0; //主子码流标识：0-主码流，1-子码流
    const transMode = 1; //传输协议：0-UDP，1-TCP
    const gpuMode = 0; //是否启用GPU硬解，0-不启用，1-启用
    const wndId = index + 1; //播放窗口序号（在2x2以上布局下可指定播放窗口）
    cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, '');
    cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, '');

    console.log(cameraIndexCode);
    this.oWebControl.JS_RequestInterface({
      funcName: 'startPreview',
      argument: JSON.stringify({
        cameraIndexCode: cameraIndexCode, //监控点编号
        streamMode: streamMode, //主子码流标识
        transMode: transMode, //传输协议
        gpuMode: gpuMode, //是否开启GPU硬解
        wndId: wndId, //可指定播放窗口
      }),
    });
  }

  //停止全部预览功能
  stopAllPreview() {
    this.oWebControl.JS_RequestInterface({
      funcName: 'stopAllPreview',
    });
  }

  closeWindow() {
    if (this.oWebControl != null) {
      this.oWebControl.JS_HideWnd(); // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
      this.oWebControl.JS_Disconnect().then(
        () => {
          // 断开与插件服务连接成功
        },
        () => {
          // 断开与插件服务连接失败
        },
      );
    }
  }
  // 推送消息
  cbIntegrationCallBack(oData: any) {
    console.log(oData.responseMsg);
    /* showCBInfo(JSON.stringify(oData.responseMsg)); */
  }

  // 创建播放实例
  initPlugin(code?: any) {
    // @ts-ignore
    this.oWebControl = new WebControl({
      szPluginContainer: 'playWnd', // 指定容器id
      iServicePortStart: 15900, // 指定起止端口号，建议使用该值
      iServicePortEnd: 15909,
      szClassId: '23BF3B0A-2C56-4D97-9C03-0CB103AA8F11', // 用于IE10使用ActiveX的clsid
      cbConnectSuccess: () => {
        // 创建WebControl实例成功
        this.oWebControl
          .JS_StartService('window', {
            // WebControl实例创建成功后需要启动服务
            dllPath: './VideoPluginConnect.dll', // 值"./VideoPluginConnect.dll"写死
          })
          .then(
            () => {
              // 启动插件服务成功
              this.oWebControl.JS_SetWindowControlCallback({
                // 设置消息回调
                cbIntegrationCallBack: this.cbIntegrationCallBack,
              });

              this.oWebControl.JS_CreateWnd('playWnd', 0, 0).then(() => {
                //JS_CreateWnd创建视频播放窗口，宽高可设定
                this.init(code); // 创建播放实例成功后初始化
              });
            },
            () => {
              // 启动插件服务失败
            },
          );
      },
      cbConnectError: () => {
        // 创建WebControl实例失败
        this.oWebControl = null;
        // @ts-ignore
        $('#playWnd').html('插件未启动，正在尝试启动，请稍候...');
        this.WebControl.JS_WakeUp('VideoWebPlugin://'); // 程序未启动时执行error函数，采用wakeup来启动程序
        this.initCount++;
        if (this.initCount < 3) {
          setTimeout(() => {
            this.initPlugin(code);
          }, 3000);
        } else {
          // @ts-ignore
          $('#playWnd').html('插件启动失败，请检查插件是否安装！');
        }
      },
      cbConnectClose: function(bNormalClose: any) {
        // 异常断开：bNormalClose = false
        // JS_Disconnect正常断开：bNormalClose = true
        console.log('cbConnectClose');
        this.oWebControl = null;
      },
    });
  }

  beforeDestroy() {
    this.closeWindow(); //关闭插件
  }
}
